import { createNextTableContext } from '@core/table';

export const BoxTransfersTableContext = createNextTableContext();
